import { memo, useMemo } from "react";
import { Box, Select, MenuItem, FormControl, IconButton, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ColorPicker from "components/UI/ColorPicker";
import ConditionalValueInput from "components/UI/ConditionalValueInput";

const ConditionRow = ({
  conditionItem,
  conditionOptions,
  handleConditionChange,
  handleValueChange,
  handleColorChange,
  handleRemoveCondition,
  index,
  selectedColumnType,
}) => {
  const selectedOption = useMemo(
    () => conditionOptions.find((option) => option.value === conditionItem.condition),
    [conditionOptions, conditionItem.condition]
  );

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
      <Tooltip title={selectedOption?.label} arrow>
        <FormControl size="small" sx={{ flex: 1 }}>
          <Select
            value={conditionItem.condition}
            onChange={(e) => handleConditionChange(index, e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>
              None
            </MenuItem>
            {conditionOptions.map((condition) => (
              <MenuItem key={condition.value} value={condition.value}>
                {condition.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Tooltip>

      <ConditionalValueInput
        condition={conditionItem.condition}
        value={conditionItem.value}
        onChange={(newValue) => handleValueChange(index, newValue)}
        selectedColumnType={selectedColumnType}
      />

      <ColorPicker
        selectedColor={conditionItem.color || "#ffffff"}
        handleColorChange={(color) => handleColorChange(index, color)}
      />

      <IconButton onClick={() => handleRemoveCondition(index)} size="small">
        <DeleteOutlineIcon />
      </IconButton>
    </Box>
  );
};

export default memo(ConditionRow);
